/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreatePaymentModel } from '../../models/create-payment-model';
import { CreatePaymentResponse } from '../../models/create-payment-response';

export interface ApiOrderPaymentsAddPost$Plain$Params {
      body?: CreatePaymentModel
}

export function apiOrderPaymentsAddPost$Plain(http: HttpClient, rootUrl: string, params?: ApiOrderPaymentsAddPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreatePaymentResponse>> {
  const rb = new RequestBuilder(rootUrl, apiOrderPaymentsAddPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreatePaymentResponse>;
    })
  );
}

apiOrderPaymentsAddPost$Plain.PATH = '/api/order/payments/add';
